import HttpClient from '@/utils/HttpClient';
import ProjectStore from '@/store/Projects';
//import SettingsStore from '@/store/Settings';
import utils from '@/utils/formatting';
//import { unformatCurrency } from '@/directives/AkCurrency';

export default {
  create(order) {
    return HttpClient.postAuthenticated(`/api/projects/${ProjectStore.activeProject.DbId}/orders`, { order });
  },
  createAddendum(addendum) {
    return HttpClient.postAuthenticated(
      `/api/projects/${ProjectStore.activeProject.DbId}/orders/${addendum.OrderId}/addendums`,
      { addendum }
    );
  },
  delete(order) {
    return HttpClient.deleteAuthenticated(`/api/projects/${ProjectStore.activeProject.DbId}/orders/${order.DbId}`);
  },
  deleteAddendum(orderId, addendumId) {
    return HttpClient.deleteAuthenticated(
      `/api/projects/${ProjectStore.activeProject.DbId}/orders/${orderId}/addendums/${addendumId}`
    );
  },
  update(order) {
    const orderToPost = { ...order };

    //orderToPost.Amount = unformatCurrency(orderToPost.Amount);

    orderToPost.PauschaliertOption = orderToPost.PauschaliertOption.toString();
    orderToPost.SkontoOption = orderToPost.SkontoOption.toString();
    orderToPost.ZahlungsPlanOption = orderToPost.ZahlungsPlanOption.toString();
    orderToPost.FreistellungCheck = orderToPost.FreistellungCheck.toString();
    orderToPost.VStrafeCheck = orderToPost.VStrafeCheck.toString();
    orderToPost.VZahlCheck = orderToPost.VZahlCheck.toString();
    orderToPost.VErfuellCheck = orderToPost.VErfuellCheck.toString();
    orderToPost.MSicherCheck = orderToPost.MSicherCheck.toString();

    if (orderToPost.FreistellungDatum == '') orderToPost.FreistellungDatum = null;
    if (orderToPost.VZahlAmount == '') orderToPost.VZahlAmount = null;
    if (orderToPost.VErfuellProzent == '') orderToPost.VErfuellProzent = null;
    if (orderToPost.MSicherProzent == '') orderToPost.MSicherProzent = null;

    /*
    if (orderToPost.AmountMwSt == null || orderToPost.AmountMwSt == '') {
      orderToPost.AmountMwSt = 0;
      order.AmountMwSt = 0;
    }
    */

    if (orderToPost.VergabeEmpfehlungDatum != null && orderToPost.VergabeEmpfehlungDatum == '')
      orderToPost.VergabeEmpfehlungDatum = null;
    if (orderToPost.OrderDate != null && orderToPost.OrderDate == '') orderToPost.OrderDate = null;

    if (orderToPost.VergabeEmpfehlungDatum)
      orderToPost.VergabeEmpfehlungDatum = utils.browserDateToSQLDate(orderToPost.VergabeEmpfehlungDatum);
    if (orderToPost.OrderDate) orderToPost.OrderDate = utils.browserDateToSQLDate(orderToPost.OrderDate);
    if (orderToPost.LastQuoteDate) orderToPost.LastQuoteDate = utils.browserDateToSQLDate(orderToPost.LastQuoteDate);

    return HttpClient.updateAuthenticated(
      `/api/projects/${ProjectStore.activeProject.DbId}/orders/${orderToPost.DbId}`,
      {
        order: orderToPost
      }
    );
  },
  updateAddendum(addendum) {
    if (addendum.NHoehe == '') addendum.NHoehe = null;
    if (addendum.NHoeheChecked == '') addendum.NHoeheChecked = null;
    if (addendum.AHoehe == '') addendum.AHoehe = null;
    if (addendum.ADate == '') addendum.ADate = null;
    if (addendum.NDate == '') addendum.NDate = null;
    if (addendum.EDate == '') addendum.EDate = null;
    if (addendum.PDate == '') addendum.PDate = null;
    return HttpClient.updateAuthenticated(
      `/api/projects/${ProjectStore.activeProject.DbId}/orders/${addendum.OrderDbId}/addendums/${addendum.DbId}`,
      {
        addendum
      }
    );
  },
  get() {
    return HttpClient.getAuthenticated(`/api/projects/${ProjectStore.activeProject.DbId}/orders`);
  },
  getAddendums(orderId) {
    return HttpClient.getAuthenticated(`/api/projects/${ProjectStore.activeProject.DbId}/orders/${orderId}/addendums`);
  },
  getAddendumById(orderId, aId) {
    return HttpClient.getAuthenticated(
      `/api/projects/${ProjectStore.activeProject.DbId}/orders/${orderId}/addendums/${aId}`
    );
  },
  getById(id) {
    return new Promise((resolve, reject) => {
      HttpClient.getAuthenticated(`/api/projects/${ProjectStore.activeProject.DbId}/orders/${id}`)
        .then(result => {
          result.Invoiced = parseFloat(result.Invoiced);
          result.FinalAmountChecked = result.FinalAmountChecked ? parseFloat(result.FinalAmountChecked) : 0;
          result.ObligoAmount =
            result.HasFinalInvoice > 0 && result.FinalAmountChecked > 0
              ? 0
              : parseFloat(result.Amount) + parseFloat(result.AmountAddendumOrdered) - result.Invoiced;
          resolve(result);
        })
        .catch(err => reject(err));
    });
  },
  getByVeId(id) {
    return HttpClient.getAuthenticated(`/api/projects/${ProjectStore.activeProject.DbId}/ve/${id}/order`);
  },
  uploadFile(id, file, field) {
    return HttpClient.uploadAuthenticated(
      `/api/projects/${ProjectStore.activeProject.DbId}/orders/${id}/upload`,
      file,
      field
    );
  },
  download(id, field) {
    return HttpClient.downloadAuthenticated(
      `/api/projects/${ProjectStore.activeProject.DbId}/orders/${id}/files/${field}`
    );
  },
  deleteFile(id, file, field) {
    return HttpClient.deleteUploadAuthenticated(
      `/api/projects/${ProjectStore.activeProject.DbId}/orders/${id}/upload/delete`,
      file,
      field
    );
  },
  getInvoicesByOrderId(id) {
    return HttpClient.getAuthenticated(`/api/projects/${ProjectStore.activeProject.DbId}/orders/${id}/invoices`);
  },
  hasInvoices(id) {
    return HttpClient.getAuthenticated(`/api/projects/${ProjectStore.activeProject.DbId}/orders/${id}/hasInvoices`);
  },
  maybeDeleted(id) {
    return new Promise((resolve, reject) => {
      HttpClient.getAuthenticated(`/api/projects/${ProjectStore.activeProject.DbId}/orders/${id}/hasObjects`).then(
        order => {
          if (order.HasInvoices == 0 && order.AmountAddendum == 0) resolve(null);
          else reject({ hasInvoices: order.HasInvoices > 0, hasAddendums: order.AmountAddendum > 0 });
        }
      );
    });
  },
  maybeAddendumDeleted(orderId, addenedumId) {
    return HttpClient.deleteAuthenticated(
      `/api/projects/${ProjectStore.activeProject.DbId}/orders/${orderId}/addendums/${addenedumId}/check`
    );
  },
  maybeUpdated(orderId, index) {
    return HttpClient.getAuthenticated(
      `/api/projects/${ProjectStore.activeProject.DbId}/orders/${orderId}/index/${index}/haschecked`
    );
  }
};
